import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Ranking from './pages/Ranking';
import Home from './pages/Home';
import GlobalRanking from './pages/GlobalRanking';
import CategoryRanking from './pages/CategoryRanking';
import Profile from './pages/Profile';
import SharedScore from './pages/SharedScore';
import VerificationGate from './components/VerificationGate';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : true; // Default to dark mode
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  return (
    <Router>
      <div className="App">
        <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        
        {/* Remove App-header class or use it differently if it constrains layout too much. 
            The ranking pages manage their own max-width. 
            I'll use a simple main wrapper.
        */}
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Weekly overview (all categories) */}
            <Route path="/ranking" element={<VerificationGate><Ranking /></VerificationGate>} />
            {/* Global / all-time overview (all categories) */}
            <Route path="/ranking-global" element={<VerificationGate><GlobalRanking /></VerificationGate>} />
            {/* Category-specific global ranking */}
            <Route path="/ranking/:categoryId" element={<VerificationGate><CategoryRanking /></VerificationGate>} />
            {/* Player profile (clickable names) */}
            <Route path="/profile/:username" element={<VerificationGate><Profile /></VerificationGate>} />
            {/* Shared score page */}
            <Route path="/score/:gameId" element={<VerificationGate><SharedScore /></VerificationGate>} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
